module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzkiIGhlaWdodD0iMzkiIHZpZXdCb3g9IjAgMCAzOSAzOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xOS41IDM5QzMwLjI2OTYgMzkgMzkgMzAuMjY5NiAzOSAxOS41QzM5IDguNzMwNDUgMzAuMjY5NiAwIDE5LjUgMEM4LjczMDQ1IDAgMCA4LjczMDQ1IDAgMTkuNUMwIDMwLjI2OTYgOC43MzA0NSAzOSAxOS41IDM5Wk0xNyAzMEwxMy42MTYgMjYuNjE2TDIxLjM5OTIgMTguODMyN0wxMy42MTYgMTEuMDQ5NUwxNyA3LjY2NTQ5TDI0Ljc4MzIgMTUuNDQ4N0wyOC4xNjczIDE4LjgzMjdMMTcgMzBaIiBmaWxsPSIjRjFEQjRCIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/right-swipe.svg
// module id = h8+7
// module chunks = 31